export default {
      id: "camera_type-usage",
      viewBox: "0 0 22 18",
      url: __webpack_public_path__ + "img/icons.svg#camera_type",
      toString: function () {
        return this.url;
      }
    }